import { css } from 'styled-components';
import { focusOutlineColor, focusOutlineOffset, focusOutlineStyle, focusOutlineWidth } from './selectors';
export const standardFocusStyleDeclarations = css`
  outline: ${focusOutlineWidth} ${focusOutlineStyle} var(--themeColorBorderFocus, ${focusOutlineColor});
  outline-offset: ${focusOutlineOffset};
`;
export const standardFocusStyleRule = css`
  &:focus-visible {
    ${standardFocusStyleDeclarations}
  }
`;